import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/comics';
import ComicsCard from '@/components/feature/ComicsCard';

export default function LatestSection() {
  const hotManga = mangaList.filter((m) => m.hot).slice(0, 8);

  const newestUpdates = mangaList
    .slice()
    .sort((a, b) => {
      const dateA = new Date(a.chapters[a.chapters.length - 1].date).getTime();
      const dateB = new Date(b.chapters[b.chapters.length - 1].date).getTime();
      return dateB - dateA;
    })
    .slice(0, 5);

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="latest-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2
              id="latest-heading"
              className="font-heading font-bold text-2xl md:text-3xl text-foreground-900"
            >
              今日热门
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              读者们正在追的热门韩漫
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {hotManga.map((manga) => (
            <ComicsCard key={`hot-${manga.id}`} manga={manga} />
          ))}
        </div>

        <div className="mt-14">
          <div className="flex items-center justify-between mb-6">
            <h3 className="font-heading font-semibold text-lg text-foreground-900">
              最近更新
            </h3>
            <Link
              to="/category/all"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap"
            >
              更多更新
            </Link>
          </div>

          <div className="bg-background-100 rounded-xl p-5 md:p-6">
            <div className="divide-y divide-background-200">
              {newestUpdates.map((manga, index) => (
                <Link
                  key={`update-${manga.id}`}
                  to={`/article/${manga.id}`}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="flex items-center gap-4 py-3.5 first:pt-0 last:pb-0 group hover:bg-background-50/80 -mx-3 px-3 rounded-lg transition-colors"
                >
                  <span className="font-heading font-bold text-lg text-foreground-300 w-6 text-center">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="w-10 h-14 rounded overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={manga.cover}
                      alt={manga.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-sm text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {manga.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {manga.latestChapter}
                    </p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                      更新
                    </span>
                    <p className="text-[10px] text-foreground-400 mt-1 whitespace-nowrap">
                      {manga.chapters[manga.chapters.length - 1].date}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}